$(document).ready(function() {

  $('h1.important').each(function(){
    $('h1:not(.important)').hide();
  });
});

function resizeContent() {
  var h=$('#content').height();
  if ($('#scroller').length>0)
    h=h+170;
  else
    h=h+120;
  $('#container').css({height:h});
}

$(window).load(function(){
  
  // center menu, and move items
  var width=$('#container').width();
  var menu_width=$('#menu ul').width();
  $('#menu ul').css({'margin-left':((width-menu_width) / 2) });
  var z_index=100;
  var pos=0;
  var margin=10;
  $('#menu li.lev1').each(function(){
    $(this).css({position:'relative', left:(pos*margin), 'z-index':z_index});
    z_index--;
    pos--;
  });
  $('#menu li.current').add('#menu li.active').css({'z-index':1000});

  // navigatie van foto's
  $('#fotos').each(function(){
    var start=$(this).attr('start');
    if (start=='')
      $('.thumb:first').set_navigatie();
    else
      $('.thumb_'+start).set_navigatie();
    $('.thumb').click(function(){
      if (!$(this).hasClass('show')) {
        $(this).set_navigatie();
      }
      else {
        if ($('#ballon').hasClass('show'))
          hideBallon();
        else
          showBallon();
      }
    });
  });
  $('.close').click(function(){
    hideBallon();
  });


  // colums
  $('#ballon .text').columns();
  resizeBallon();
  resizeContent();
  
});

function resizeBallon() {
  var bh=$('#ballon').height();
  var hh=$('#ballon .text').height() + 30;
  if (hh<bh) {
    $('#ballon').css({height:hh});
    bh=hh;
  }
  var bf=$('#ballon.foto').each(function(){
    var h=$(this).height()+75;
    $(this).css({'margin-top':-h});
  });
}

function showBallon() {
  $('.thumb.show .infobutton').hide();
  $('#ballon').addClass('show').show();
  // get text from info
  var html=$('.thumb.show').find('.border').html();
  $('#ballon .html').html(html);
  // columnize text
  // $('#ballon .text').columns();
  resizeBallon();
}

function hideBallon() {
  $('#ballon').hide().removeClass('show'); 
  $('.thumb.show .infobutton').show();
}

(function($) {
	$.fn.set_navigatie = function() {
    $('.infobutton').hide();
    // move
    var item=$(this);
    $('.thumb').removeClass('show');
    $(item).addClass('show');
    // shift
    var inner=$('#fotos').width()/2;
    var current=$(item).position().left;
    var shift= inner - current - $(item).width()/2;
    $('#inner').animate({left:shift});
    // set info button
    $('.thumb.show .infobutton').show();
    // show image
    var src=$(item).find('img').attr('src');
    src=src.replace(/_thumb_/,'_normal_');
    $('#big_foto img').attr('src',src);
    // hide ballon (new text will be shown in showBallon())
    hideBallon();
	};
})(jQuery);


(function($) {
	$.fn.columns = function() {
    $(this).each(function(){
      var h=$(this).html();
      var columns=h.split(/<hr>/i);
      var nrColumns=columns.length;
      if (nrColumns==2) {
        var newHtml='<div class="column first">'+columns[0]+'</div><div class="column last">'+columns[1]+'</div>';
        $(this).html(newHtml);
        // resizeContent();
      }
    });
	};
})(jQuery);
